const carouselSection = document.getElementById('carousel-section');
const buttons = document.querySelectorAll('#story-selector button');
const slides = document.querySelectorAll('.story-slide');
const slideImages = document.querySelectorAll('.story-slide-image');
const fills = Array.from(buttons).map((btn) =>
  btn.parentElement ? btn.parentElement.querySelector('.button-fill') : null
);

let currentIndex = 0;
const duration = 9000; // full slide duration
let hasStarted = false;
let lastTimestamp: number | null = null;
let elapsed = 0;
let isVisible = false;

function setActiveSlide(index: number) {
  // Show/hide slides
  slides.forEach((s, i) => s.classList.toggle('hidden', i !== index));
  slideImages.forEach(
    (img, i) => ((img as HTMLElement).style.opacity = i === index ? '1' : '0')
  );

  // Buttons
  buttons.forEach((b, i) => {
    b.classList.toggle('opacity-100', i === index);
    b.classList.toggle('opacity-40', i !== index);
  });

  // Reset fills
  fills.forEach((fill) => {
    if (!fill || !(fill instanceof HTMLElement)) return;
    fill.style.transition = 'none';
    fill.style.width = '0%';
  });

  currentIndex = index;
  elapsed = 0;
  lastTimestamp = null;
}

function animate(timestamp: number) {
  if (!isVisible) {
    requestAnimationFrame(animate);
    return;
  }

  if (lastTimestamp === null) lastTimestamp = timestamp;
  const delta = timestamp - lastTimestamp;
  lastTimestamp = timestamp;
  elapsed += delta;

  // Update active fill
  const activeFill = fills[currentIndex];
  if (activeFill && activeFill instanceof HTMLElement) {
    const progress = Math.min(elapsed / duration, 1);
    activeFill.style.width = `${progress * 100}%`;
  }

  if (elapsed >= duration) {
    const nextIndex = (currentIndex + 1) % slides.length;
    setActiveSlide(nextIndex);
  }

  requestAnimationFrame(animate);
}

// Buttons click
buttons.forEach((btn) => {
  btn.addEventListener('click', () => {
    const idx = parseInt((btn as HTMLButtonElement).dataset.index || '0');
    setActiveSlide(idx);
  });
});

// Intersection Observer
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      isVisible = entry.isIntersecting;
      if (isVisible && !hasStarted) {
        setActiveSlide(0);
        hasStarted = true;
      }
    });
  },
  { threshold: 0.5 }
);

if (carouselSection) {
  observer.observe(carouselSection);
  requestAnimationFrame(animate);
}
